import React from "react";
import styled from "styled-components";

export const SiteFooterWrapper = styled.section`
  text-align: center;
  color: #fff;
  margin: 10px 0 120px 0;
  background-color: #898989;
  display: inline-block;
  padding: 0 9px;
  a {
    color: #fff;
  }
`;

const SiteFooter = (props) => (
  <div style={{ textAlign: "center" }}>
    <SiteFooterWrapper>
      Copyright &copy; {new Date().getFullYear()}{" "}
      <a href="//www.dreamchimney.com/" target="_top">
        Dream Chimney
      </a>{" "}
      Inc.
    </SiteFooterWrapper>
  </div>
);

export default SiteFooter;
